import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Nav from 'react-bootstrap/Nav';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
export default function SearchAppBar(props) {

  return (
<Navbar bg="light" expand="lg">

    <Form inline>
      <FormControl type="text"  value={props.search_filter} placeholder='Input Secret Key'  onChange={props.change_filter} placeholder="Search" className="mr-sm-2" />
    </Form>
</Navbar>
  );
}